'use client'

import SectionLayout from '@component/layout/section'
import classNames from 'classnames'
import { get, map, size } from 'lodash-es'
import { useToggle } from 'react-use'

export default function FeaturesAmenities({
  data
}) {

  const [showAll, toggleAll] = useToggle(false)
  const list = get(data, 'featureAmenities', [])

  return size(list) > 0 && (
    <SectionLayout title='Facilities & Amenities'>
      <div className='grid grid-cols-1 sm:grid-cols-2 gap-24 mb-24'>
        {
          map(list, (item, idx) => (
            <div
              key={idx}
              className={classNames(
                'text-font text-base flex items-center before:w-16 before:h-16 before:bg-secondary before:rounded-sm before:mr-16',
                showAll || idx < 6 ? 'flex' : 'hidden'
              )}
            >
              {item}
            </div>
          ))
        }
      </div>
      {
        size(list) > 6 && (
          <button className='button-primary-out gap-x-6' onClick={toggleAll}>
            {showAll ? 'Show less' : 'Show all'}
            <i className={classNames('icon icon-arrow-down', { 'rotate-180': showAll })} />
          </button>
        )
      }
    </SectionLayout>
  )
}